import $ = require('zepto-modules/zepto');
import { components } from './gs-components';

import 'zepto-modules/event';
import 'zepto-modules/ajax';
import 'zepto-modules/form';
import 'zepto-modules/ie';
//import 'zepto-modules/data';

// SC-432 (sanctioned): Zepto collections are array-like but not iterable. The old
// webpack build's es5 TS emit compiled `for...of` into index loops, which masked that;
// the modern vite target keeps native for...of, so give collections the array iterator.
$['fn'][Symbol.iterator] = Array.prototype[Symbol.iterator];

$['extend']($['fn'], {
	gs: function(prop, ...args) {

		let vals = [];

		// No prop or arguments. Just return the component(s).
		if (prop === undefined || !isNaN(prop)) {
			this.filter('.gsc').each(function() {
				let component = components.getController(this);
				vals.push(component);
			});
			return prop === undefined ? vals : vals[prop];
		}

		// Just a property, no arguments. If it's a method,
		// execute it. If it's a property, get it.
		if (args.length == 0) {
			this.filter('.gsc').each(function() {
				let component = components.getController(this);
				let isMethod = (typeof component[prop] == 'function');
				vals.push(isMethod ? component[prop]() : component[prop]);
			});
		}

		// A property and one argument. If it's a property,
		// set it. If it's a method, execute it with the arg.
		if (args.length == 1) {
			this.filter('.gsc').each(function() {
				let component = components.getController(this);
				let isMethod = (typeof component[prop] == 'function');
				vals.push(isMethod
					? vals.push(component[prop](args[0]))
					: component[prop] = args[0]
				);
			});
		}

		// More than one argument? Probably a method. Execute it.
		if (args.length > 1) {
			this.filter('.gsc').each(function() {
				let component = components.getController(this);
				let isMethod = (typeof component[prop] == 'function');
				vals.push(isMethod
					? component[prop].apply(args)
					: undefined
				);
			});
		}

		return vals;
	}
});

let resizeDebounceTimer;
let scrollDebounceTimer;

// Lifecycle events
$('body').one('gs:loaded', function() {
	$('.gsc-init').removeClass('gsc-init').gs('gsOnInit');
	$('.gsc-resize').gs('gsOnWindowResize');

	$(window).on({
		resize: () => {
			clearTimeout(resizeDebounceTimer);
			resizeDebounceTimer = setTimeout(() => $('.gsc-resize').gs('gsOnWindowResize'), 15);
		},
		scroll: () => {
			clearTimeout(scrollDebounceTimer);
			scrollDebounceTimer = setTimeout(() => $('.gsc-scroll').gs('gsOnPageScroll', window.scrollY), 15);
		},
		beforeunload: () => {
			$('.gsc-unload').gs('gsOnPageUnload');
		}
	});
});

export default $;
